﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customProductSheetImageTableList from './tpl/customProductSheetImageTableList.html';
import View_CustomProductSheetImageTableListItem from './customProductSheetImageTableListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customProductSheetImageTableList',
    childViewContainer: '#customProductSheetImageTableList',
    childView: View_CustomProductSheetImageTableListItem,
    getTemplate: function () {
        return tpl_customProductSheetImageTableList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
